import AttributesCoumn from "./AttributesCoumn";

export default AttributesCoumn;
